module.exports = __webpack_public_path__ + "img/Teaching-Research Case - Dark Gray.26419b74.png";